<template>
  <div class="filial-menu-list">
    <v-container fluid>
      <breadcrumbs />
      <v-row>
        <v-col cols="9">
          <h1>
            Добавьте опциональные блюда в меню филиала
          </h1>
          <h2 v-if="!loading" class="mb-1 font-weight-light">
            Источник: "{{ sourceName }}"
          </h2>
        </v-col>
        <v-col class="text-right">
          <v-btn
            class="filial-menu-list_go-back"
            depressed
            large
            @click="goToListPage"
          >
            <font-awesome-icon icon="chevron-left" />&nbsp;
            Назад к списку
          </v-btn>
        </v-col>
      </v-row>
      <loader v-if="loading" />
      <v-alert v-else-if="error" color="error" dark>
        Ошибка загрузки: {{ error }}
      </v-alert>
      <v-row v-else>
        <v-col>
          <v-card class="stop-list-page-content">
            <v-card-title>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Укажите название блюда"
                outlined
                single-line
                hide-details
                clearable
              ></v-text-field>
            </v-card-title>
            <div class="stop-list-items">
              <div v-if="search && noMenuItemFound" class="stop-list-items-is-empty">
                Ничего не найдено
              </div>
              <template v-else>
                <div class="filial-menu-categories">
                  <categories-horizontal-filter
                    v-model="selectedCategory"
                    :categories="categories"
                  />
                </div>

                <v-row>
                  <v-col
                    v-for="item in menuItemsForListing"
                    :key="item.id"
                    cols="6"
                    md="3"
                    xl="2"
                  >
                    <filial-menu-item
                      :item="item"
                      :activated="item.isAvailableInFilials"
                      @add="showInfoPopup(item)"
                      @remove="showRemoveDialog(item)"
                      @image-click="showInfoPopup(item)"
                    />
                  </v-col>
                </v-row>
              </template>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <menu-item-info-popup
        v-model="infoPopupShow"
        :menu-item="selectedMenuItem"
        :activated="selectedMenuItem.isAvailableInFilials"
        :loading="sendRequest"
        @add="addToFilialMenu"
        @remove="showRemoveDialog(selectedMenuItem)"
      />
      <remove-from-filial-menu-dialog
        v-model="removeDialogShow"
        :menu-item="selectedMenuItem"
        :loading="sendRequest"
        @confirm="removeFromFilialMenu"
      />
    </v-container>
  </div>
</template>

<script>
  import Loader from '@/components/loader/Loader.vue'
  import CategoriesHorizontalFilter from '@/components/filters/CategoriesHorizontalFilter.vue'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'
  import { mapGetters } from 'vuex'
  import _ from 'lodash'
  import MenuItemsDataService from '@/services/api/MenuItemsDataService'
  import RemoveFromFilialMenuDialog from '@/components/filial-menu/RemoveFromFilialMenuDialog.vue'
  import FilialMenuItem from '@/components/filial-menu/FilialMenuItem.vue'
  import MenuItemInfoPopup from '@/components/filial-menu/MenuItemInfoPopup.vue'
  import SourceDataService from '@/services/api/SourceDataService'

  export default {
    name: 'FilialMenuEdit',
    components: { MenuItemInfoPopup, FilialMenuItem, RemoveFromFilialMenuDialog, CategoriesHorizontalFilter, Loader },
    mixins: [mixinSnackbarMessage],
    data () {
      return {
        error: null,
        loading: false,
        search: null,
        menuItems: [],
        selectedCategory: 0,
        addDialogShow: false,
        infoPopupShow: false,
        removeDialogShow: false,
        selectedMenuItem: {},
        sendRequest: false,
        sourceItem: null,
        sourceName: null,
      }
    },
    computed: {
      ...mapGetters({
        filialId: 'branches/getGlobalFilialId',
      }),

      filter () {
        const filterData = {}

        if (this.$route.query.source && this.$route.query.source !== 'sushiset') {
          filterData.source = this.$route.query.source
        }

        return filterData
      },

      filteredMenuItem () {
        let data = this.menuItems

        if (this.search) {
          data = data.filter(item => {
            return item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
          })
        }

        data = _.orderBy(data, ['isAvailableInFilials'], ['desc'])

        return data
      },

      menuItemsForListing () {
        if (!this.selectedCategory) {
          return this.filteredMenuItem
        }

        return this.filteredMenuItem.filter(item => {
          return item.categories.map(cat => cat.id).includes(this.selectedCategory)
        })
      },

      categories () {
        const data = []

        this.filteredMenuItem.forEach(item => {
          if (item.categories) {
            item.categories.forEach(cat => {
              if (!_.find(data, (c) => c.id === cat.id)) {
                data.push(cat)
              }
            })
          }
        })

        return _.orderBy(data, ['sortOrder'])
      },

      noMenuItemFound () {
        return _.isEmpty(this.filteredMenuItem)
      },
    },

    async created () {
      this.loading = true
      try {
        await this.loadSource()
        await this.loadMenuItems()
      } catch (err) {
        this.error = this.getErrorMessageFromResponse(err)
      }
      this.loading = false
    },
    methods: {
      goToListPage () {
        this.$router.push({ name: 'filialMenuList', query: this.filter })
      },
      async loadMenuItems () {
        this.menuItems = await MenuItemsDataService.getOptionalMenu(this.filialId, this.filter)
      },
      async loadSource () {
        if (this.$route.query.source) {
          this.sourceItem = await SourceDataService.getOne(this.$route.query.source)
          console.log({ sourceItem: this.sourceItem })
          this.sourceName = this.sourceItem?.name
        } else {
          this.sourceName = 'Основное меню'
        }
      },

      showAddDialog (menuItem) {
        this.selectedMenuItem = menuItem
        this.addDialogShow = true
      },
      showInfoPopup (menuItem) {
        this.selectedMenuItem = menuItem
        this.infoPopupShow = true
      },
      showRemoveDialog (menuItem) {
        this.selectedMenuItem = menuItem
        this.infoPopupShow = false
        this.removeDialogShow = true
      },

      async addToFilialMenu (menuItemId) {
        this.sendRequest = true
        try {
          await MenuItemsDataService.addToFilial(menuItemId, this.filialId)
          this.markMenuItemAvailability(menuItemId, true)
          this.addDialogShow = false
          this.infoPopupShow = false
        } catch (err) {
          this.showErrorFromResponse(err)
        }
        this.sendRequest = false
      },

      async removeFromFilialMenu (menuItemId) {
        this.sendRequest = true
        try {
          await MenuItemsDataService.removeFromFilial(menuItemId, this.filialId)
          this.markMenuItemAvailability(menuItemId, false)
          this.removeDialogShow = false
          this.infoPopupShow = false
        } catch (err) {
          this.showErrorFromResponse(err)
        }
        this.sendRequest = false
      },
      markMenuItemAvailability (menuItemId, value) {
        this.menuItems = this.menuItems.map(item => {
          if (item.id === menuItemId) {
            item.isAvailableInFilials = value
          }
          return item
        })
      },
    },
  }
</script>

<style scoped lang="less">
.filial-menu-list {

  &_go-back {
    padding-left: 40px !important;
    padding-right: 40px !important;
    background: @color-btn-grey !important;
  }

  .stop-list-items {
    padding: 0 16px 0 16px;

    &-is-empty {
      min-height: 200px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 500;
      font-size: 18px;
    }
  }

  &-content {
    min-height: calc(100vh - 200px);
  }

}
</style>
